import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment.prod';
import { AppConstants } from 'src/app/app.constants';
import { MiddlearticlesInterface } from 'src/_lib/interfaces/performance-section.interface';
import { WebinfoService } from 'src/_lib/service/webinfo.service';
import { SubscribePopupComponent } from './subscribe-popup/subscribe-popup.component';
import { NgIf } from '@angular/common';
import { SubscribeCh1Component } from './subscribe-ch1/subscribe-ch1.component';
import { SubscribeCh2Component } from './subscribe-ch2/subscribe-ch2.component';
import { SubscribeCh11Component } from './subscribe-ch11/subscribe-ch11.component';
import { BrowserService } from 'src/_lib/service/browser.service';

@Component({
  standalone: true,
  selector: 'app-subscribe',
  templateUrl: './subscribe.component.html',
  styleUrls: ['./subscribe.component.scss'],
  imports: [ReactiveFormsModule, NgIf, SubscribeCh1Component, SubscribeCh2Component, SubscribeCh11Component],
  encapsulation: ViewEncapsulation.None,
  host: { 'ngSkipHydration': 'true' }
})
export class SubscribeComponent implements OnInit {
  firstObj: number = this.appConstants.firstObj;
  cdnImagePath = environment.cdnImagePath;
  commonImagePath: string = environment.commonImagePath;
  emaildata: MiddlearticlesInterface[] = [];
  loading: boolean = false;
  successMessage: string = '';
  errorMessage: string = '';
  backgroundImage: string = '';
  extractedContent: { secondDiv: string; firstP: string } = { secondDiv: '', firstP: '' };
  emailForm: FormGroup;
  title: string = '';
  chTheme2 = environment.chTheme2;
   chTheme4 = environment.chTheme4;
   chTheme11 = environment.chTheme11;
   index9:any;
   chTheme13 = environment.chTheme13;
   chTheme14 = environment.chTheme14;
   chTheme15 = environment.chTheme15;
   chTheme16 = environment.chTheme16;


  constructor(
    private browser: BrowserService,
    private appConstants: AppConstants,
    private webinfoHttp: WebinfoService,
    private fb: FormBuilder,
    private dialog: MatDialog
  ) {
    this.emailForm = this.fb.group({
      email: [
        '',
        [
          Validators.required,
          Validators.email,
          Validators.pattern(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
          ),
        ],
      ],
    });
  }

  ngOnInit(): void {
    this.webinfoHttp.infoList().subscribe((data) => {
      this.emaildata = data[this.firstObj].data;
      this.index9 = this.emaildata.find(
        item => item.home_page_set_index === 9
      );
      // const backImage = this.emaildata.find((item) => item.title === 'Join Our Email List');
      // this.title = backImage?.title;
      // this.backgroundImage = backImage?.secondary_image;
      // const shortDescription = backImage?.short_description || '';
      // this.extractedContent = this.extractContentFromHTML(shortDescription);
    });
  }

  onSubmit(): void {
    if (this.emailForm.valid) {
      const email = this.emailForm.get('email')?.value;
      this.webinfoHttp.subscribe(email).subscribe({
        next: (response) => {
          const res = response[0];
          if (response[0]?.success === true) {
            this.openSubscribePopUpSuccess();
            setTimeout(() => {
              this.emailForm.reset();
              this.errorMessage = '';
            }, 2000);
          } else {
            this.errorMessage = res?.data || 'Please enter a valid email address.';
          }
        },
      });
    } else {
      this.markFormGroupTouched(this.emailForm);
      this.errorMessage = 'Please enter a valid email address.';
    }
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach((control) => {
      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      } else {
        control.markAsTouched();
      }
    });
  }

  openSubscribePopUpSuccess(): void {
  if (!this.browser.isBrowser) {
    return;
  }
  const dialogRef = this.dialog.open(SubscribePopupComponent, {
    width: '250px',
    data: { message: 'You have successfully signed up to get the best deals.'},
  });
  dialogRef.afterClosed().subscribe(() => { });
}

  // extractContentFromHTML(html: string): { secondDiv: string; firstP: string } {
  //   const parser = new DOMParser();
  //   const doc = parser.parseFromString(html, 'text/html');
  //   const secondDiv = doc.querySelectorAll('div')[1]?.outerHTML || '';
  //   const firstP = doc.querySelectorAll('p')[0]?.outerHTML || '';
  //   return { secondDiv, firstP };
  // }
}